import Accordion from "../../../../../components/Accordion/Accordion";
import DatiAnagrafici from "./DatiAnagrafici";
import InformazioniGenerali from "./InformazioniGenerali";
import Button from "../../../../../components/Button/Button";
import {useHistory} from "react-router";
import Utils from "../../../../../utils/Utils";
import ModaleAnnulla from "../../../../../components/modaleAnnulla/ModaleAnnulla";
import AnagraficaService from "../../../../../services/AnagraficaService";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";
import AssistentiService from "../../../../../services/AssistentiService";
import Spinner from "../../../../../components/spinner/Spinner";
import {useState} from "react";

function DatiPersonali(props) {

    const datiAnagrafici = (<div><DatiAnagrafici datiAnagrafici={props.datiAnagrafici}/></div>)
    const informazioniGenerali = (<div><InformazioniGenerali/></div>)
    const history = useHistory()
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : {}
    const fileReducer = useSelector(state => state.fileReducer)
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const dispatch = useDispatch()
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const [showSpinner, setShowSpinner] = useState(false)

    function validateConferma() {
        if (getAssistente && getAssistente.infoGenerali) {
            let stateInfoGenerali = getAssistente.infoGenerali
            if (!stateInfoGenerali.patente ||
                (stateInfoGenerali.patente && stateInfoGenerali.patente === "1" && !stateInfoGenerali.tipologiaPatente) ||
                !stateInfoGenerali.italianoMadreLingua || stateInfoGenerali.italianoMadreLingua === "2" && !stateInfoGenerali.linguaItalianaParlataCompresa ||
                !stateInfoGenerali.italianoMadreLingua || stateInfoGenerali.italianoMadreLingua === "2" && (!stateInfoGenerali.linguaParlata || stateInfoGenerali.linguaParlata[0] === "" || stateInfoGenerali.linguaParlata.length === 0) ||
                !stateInfoGenerali.corso || stateInfoGenerali.corso === "1" && !stateInfoGenerali.tipologiaEnteCorso) return true
        }
        if (getAssistente && getAssistente.datiAnagrafici) {
            let stateDatiAnagrafici = getAssistente.datiAnagrafici
            if (!(stateDatiAnagrafici.nome && stateDatiAnagrafici.cognome && stateDatiAnagrafici.codiceFiscale && stateDatiAnagrafici.dataNascita && stateDatiAnagrafici.comuneNascita && stateDatiAnagrafici.comuneNascita.codice && stateDatiAnagrafici.cittadinanza && stateDatiAnagrafici.cittadinanza.codice && stateDatiAnagrafici.sesso && Utils.isDateValid(Utils.transformDateForBackend(stateDatiAnagrafici.dataNascita), "-"))) {
                return true
            }
            if (stateDatiAnagrafici.comuneNascita && stateDatiAnagrafici.comuneNascita.codice && stateDatiAnagrafici.comuneNascita.codice.length > 4 && (!stateDatiAnagrafici.provinciaNascita || !stateDatiAnagrafici.provinciaNascita.codice)) {
                return true
            }
            if(!stateDatiAnagrafici.documenti ||  stateDatiAnagrafici.documenti && stateDatiAnagrafici.documenti.length <= 0){
                return true
            }

            if(stateDatiAnagrafici.documenti[0] && !Utils.isEmpty(stateDatiAnagrafici.documenti[0]) &&
                (!stateDatiAnagrafici.documenti[0].dataRilascio || !stateDatiAnagrafici.documenti[0].enteRilascio || !stateDatiAnagrafici.documenti[0].dataScadenza ||
                (stateDatiAnagrafici.documenti[0].dataScadenza && !Utils.isDateValid(Utils.transformDateForBackend(stateDatiAnagrafici.documenti[0].dataScadenza), "-")) ||
                (stateDatiAnagrafici.documenti[0].dataRilascio && !Utils.isDateValid(Utils.transformDateForBackend(stateDatiAnagrafici.documenti[0].dataRilascio), "-")))){
                return true
            }

            if(stateDatiAnagrafici.documenti[1] && !Utils.isEmpty(stateDatiAnagrafici.documenti[1]) &&
                (!stateDatiAnagrafici.documenti[1].dataRilascio || !stateDatiAnagrafici.documenti[1].enteRilascio || !stateDatiAnagrafici.documenti[1].dataScadenza ||
                (stateDatiAnagrafici.documenti[1].dataScadenza && !Utils.isDateValid(Utils.transformDateForBackend(stateDatiAnagrafici.documenti[1].dataScadenza), "-")) ||
                (stateDatiAnagrafici.documenti[1].dataRilascio && !Utils.isDateValid(Utils.transformDateForBackend(stateDatiAnagrafici.documenti[1].dataRilascio), "-")))){
                return true
            }

            if(!fileReducer || fileReducer && !fileReducer.documentoIdentita && !fileReducer.permessoSoggiorno ||
                fileReducer && fileReducer.documentoIdentita && fileReducer.permessoSoggiorno &&
                (!stateDatiAnagrafici.documenti || stateDatiAnagrafici.documenti && stateDatiAnagrafici.documenti.length <= 1 ||
                    stateDatiAnagrafici.documenti && (Utils.isEmpty(stateDatiAnagrafici.documenti[0]) || Utils.isEmpty(stateDatiAnagrafici.documenti[1])))){
                return true
            }
            if (!(stateDatiAnagrafici.indirizzi && stateDatiAnagrafici.indirizzi.length > 0 && stateDatiAnagrafici.indirizzi[0] && stateDatiAnagrafici.indirizzi[0].indirizzo && stateDatiAnagrafici.indirizzi[0].comune && stateDatiAnagrafici.indirizzi[0].comune.codice && stateDatiAnagrafici.indirizzi[0].numeroCivico)) {
                return true
            }
            if (stateDatiAnagrafici.indirizzi && stateDatiAnagrafici.indirizzi.length > 0 && stateDatiAnagrafici.indirizzi[0] && stateDatiAnagrafici.indirizzi[0].comune && stateDatiAnagrafici.indirizzi[0].comune.codice.length > 4 && (!stateDatiAnagrafici.indirizzi[0].cap || !stateDatiAnagrafici.indirizzi[0].provincia || !stateDatiAnagrafici.indirizzi[0].provincia.codice)) {
                return true
            }
            if (!(stateDatiAnagrafici.contatti && stateDatiAnagrafici.contatti.length > 0 && stateDatiAnagrafici.contatti[0] && stateDatiAnagrafici.contatti[0].cellulare)) {
                return true
            }
            if (stateDatiAnagrafici.residenzaDiversaDomicilio === "true") {
                if (!(stateDatiAnagrafici.indirizzi && stateDatiAnagrafici.indirizzi.length > 0 && stateDatiAnagrafici.indirizzi[1] && stateDatiAnagrafici.indirizzi[1].indirizzo && stateDatiAnagrafici.indirizzi[1].comune && stateDatiAnagrafici.indirizzi[1].comune.codice && stateDatiAnagrafici.indirizzi[1].numeroCivico)) {
                    return true
                }
                if (stateDatiAnagrafici.indirizzi && stateDatiAnagrafici.indirizzi.length > 0 && stateDatiAnagrafici.indirizzi[1] && stateDatiAnagrafici.indirizzi[1].comune && stateDatiAnagrafici.indirizzi[1].comune.codice.length > 4 && (!stateDatiAnagrafici.indirizzi[1].cap || !stateDatiAnagrafici.indirizzi[1].provincia || !stateDatiAnagrafici.indirizzi[1].provincia.codice)) {
                    return true
                }
            }
        }
    }

    function onClickButtonAnnulla() {
        let path = sessioneUtente && sessioneUtente.tipoUtente === "01" ? "/registro" : "/home"
        history.push({
            pathname: path
        })
    }

    function onClickButtonProsegui() {
        setShowSpinner(true)
        let path = sessioneUtente && sessioneUtente.tipoUtente === "01" ? "/wizardRegistro" : "/profilo"
        if (getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato) {
            modificaWizardProsegui()
        }
        history.push({
            pathname: path,
            steps: [{
                nome: "1. DATI PERSONALI",
                codiceStep: "01",
                cliccabile: true
            }, {
                nome: "2. LAVORO E DISPONIBILITA'",
                codiceStep: "02",
                cliccabile: false
            }, {nome: "3. REQUISITI E CONDIZIONI", codiceStep: "03", cliccabile: false}],
            stepAttivo: "02"
        })
    }


    function modificaWizardProsegui() {
        let json = Utils.removeEmptyObject(createJson())
        let idAssistente = getAssistente.assistente.idAssistente
        let jsonInsertCandidato = Utils.createJsonInsertCandidato(getAssistente.datiAnagrafici)
        AnagraficaService.modificaCandidato(Utils.removeEmptyValueFromObject(jsonInsertCandidato)).then(resInserimentoCandidato => {
            let idCandidato = resInserimentoCandidato.data.id
            if (sessioneUtente.tipoUtente === "02") {
                AnagraficaService.getCandidato(resInserimentoCandidato.data.id).then(resGetCandidato => {
                    let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(resGetCandidato.data, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, false)
                    dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
                    callToModificaAssistente(idAssistente, json, idCandidato)
                }).catch(reason => {
                    console.log("Errore Operation GET Candidato: " + reason)
                    setShowSpinner(false)
                })
            } else {
                AnagraficaService.getCandidato(idCandidato).then(res => {
                    let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(res.data, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, false)
                    dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
                    callToModificaAssistente(idAssistente, json, idCandidato)
                }).catch(reason => {
                    console.log("Errore Operation GET Candidato: " + reason)
                    setShowSpinner(false)
                })
            }
        }).catch(reason => {
            console.log("Errore Operation PUT Candidato: " + reason)
            setShowSpinner(false)
        })
    }

    function callToModificaAssistente(idAssistente, json, idCandidato) {
        AssistentiService.modificaAssistente(idAssistente, json).then(res => {
            uploadFile(idCandidato)
        }).catch(reason => {
            console.log("Errore Operation PUT Assistente: " + reason)
            setShowSpinner(false)
        })
    }

    function uploadFile(idCandidato) {
        let jsonParam = {
            idCandidato: idCandidato,
            documentoIdentita: fileReducer && fileReducer.documentoIdentita ? fileReducer.documentoIdentita : "",
            permessoSoggiorno: fileReducer && fileReducer.permessoSoggiorno ? fileReducer.permessoSoggiorno : "",
            attestati: fileReducer && fileReducer.attestati ? fileReducer.attestati : ""
        }
        AssistentiService.modificaUploadFile(idCandidato, Utils.removeEmptyValueFromObject(jsonParam)).then(res => {
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation Caricamento File: " + reason)
        })

    }

    function createJson() {
        let paramsWizard = {
            idCandidato: getAssistente.assistente && getAssistente.assistente.idCandidato ? getAssistente.assistente.idCandidato : "",
            datiPersonali: {
                infoGenerali: getAssistente.infoGenerali
            },
            lavoroDisponibilita: {
                esperienzeLavorative: getAssistente.esperienzeLavorative,
                disponibilitaOfferta: getAssistente.disponibilitaOfferta
            },
            requisitiCondizioni: {
                requisitiIscrizione: getAssistente.requisitiIscrizione,
                datiPersonali: getAssistente.datiPersonali,
                valutazione: getAssistente.valutazione
            }
        }

        if (getAssistente.disponibilitaOfferta && getAssistente.disponibilitaOfferta.comune && getAssistente.disponibilitaOfferta.comune.length > 0) {
            let p = {
                type: "MultiPoint",
                coordinates: []
            }
            getAssistente.disponibilitaOfferta.comune.forEach(c => {
                let coordinatesComune = [c.longitudine, c.latitudine]
                p.coordinates.push(coordinatesComune)
            })
            paramsWizard.lavoroDisponibilita.disponibilitaOfferta.location = p
        }
        return paramsWizard
    }

    return (
        <div style={{marginTop: "2rem"}}>
            <Spinner show={showSpinner}/>
            <span style={{fontSize: "24px"}}>Compila Scheda Assistente (1 di 3)</span>
            <div style={{marginTop: "2rem"}}>
                <Accordion
                    id={"AccordionDatiAnagrafici"}
                    headerText={"Dati Anagrafici"}
                    accordionBody={datiAnagrafici}
                />
                <Accordion
                    id={"AccordionInformazioniGenerali"}
                    headerText={"Informazioni Generali"}
                    accordionBody={informazioniGenerali}
                />
            </div>
            <div className={"row"}>
                <div className={"col-6"} style={{textAlign: "left"}}>
                    <Button
                        id={"ButtonAnnulla"}
                        typeButton={"White"}
                        disabled={false}
                        text={"Annulla"}
                        style={{minHeight: "50px", minWidth: "150px"}}
                        dataTarget={"modalModificaUtente"}
                        dataToggle={"modal"}
                        dataBackdrop={"static"}
                        dataKeyboard={false}
                        body={<ModaleAnnulla onClick={onClickButtonAnnulla}/>}
                        header={"Attenzione!"}
                    />

                </div>
                <div className={"col-6"} style={{textAlign: "right"}}>
                    <Button
                        id={"ButtonProsegui"}
                        onClick={onClickButtonProsegui}
                        typeButton={"Blue"}
                        disabled={validateConferma()}
                        text={getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato ? "Salva e prosegui" : "Prosegui"}
                        style={{minHeight: "50px", minWidth: "150px"}}
                    />
                </div>
            </div>
        </div>
    )
}

export default DatiPersonali
